import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const LEAD_SIDE_RAIL_ID = "lead-details-side-rail";

/** Renders children into the lead details right-hand side rail when it exists. */
export function LeadSideRailPortal({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const sync = () => {
      setTarget(document.getElementById(LEAD_SIDE_RAIL_ID));
    };
    sync();
    const frame = window.requestAnimationFrame(sync);
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => {
      window.cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, []);

  if (!target || children == null) {
    return null;
  }

  return createPortal(children, target);
}

export default LeadSideRailPortal;
